import { api } from '@/lib/api'
import type {
  CreateRuleRequest,
  FieldsResponse,
  UpdateRuleRequest,
  VisibilityRule,
} from './types'

export async function getFields(objectType: string): Promise<FieldsResponse> {
  const r = await api.get<FieldsResponse>(`/api/access/fields/${objectType}`)
  return r.data
}

export async function listRules(roleCode: string, objectType: string): Promise<VisibilityRule[]> {
  const r = await api.get<VisibilityRule[]>(`/api/access/roles/${roleCode}/visibility/${objectType}`)
  return r.data
}

export async function createRule(roleCode: string, objectType: string, payload: CreateRuleRequest): Promise<VisibilityRule> {
  const r = await api.post<VisibilityRule>(`/api/access/roles/${roleCode}/visibility/${objectType}`, payload)
  return r.data
}

export async function updateRule(roleCode: string, objectType: string, ruleId: number, payload: UpdateRuleRequest): Promise<VisibilityRule> {
  const r = await api.put<VisibilityRule>(`/api/access/roles/${roleCode}/visibility/${objectType}/${ruleId}`, payload)
  return r.data
}

export async function deleteRule(roleCode: string, objectType: string, ruleId: number): Promise<void> {
  await api.delete(`/api/access/roles/${roleCode}/visibility/${objectType}/${ruleId}`)
}

// Team visibility rules - shape identical to role rules, only path differs.
export async function listTeamRules(teamId: number, objectType: string): Promise<VisibilityRule[]> {
  const r = await api.get<VisibilityRule[]>(`/api/access/teams/${teamId}/visibility/${objectType}`)
  return r.data
}

export async function createTeamRule(teamId: number, objectType: string, payload: CreateRuleRequest): Promise<VisibilityRule> {
  const r = await api.post<VisibilityRule>(`/api/access/teams/${teamId}/visibility/${objectType}`, payload)
  return r.data
}

export async function updateTeamRule(teamId: number, objectType: string, ruleId: number, payload: UpdateRuleRequest): Promise<VisibilityRule> {
  const r = await api.put<VisibilityRule>(`/api/access/teams/${teamId}/visibility/${objectType}/${ruleId}`, payload)
  return r.data
}

export async function deleteTeamRule(teamId: number, objectType: string, ruleId: number): Promise<void> {
  await api.delete(`/api/access/teams/${teamId}/visibility/${objectType}/${ruleId}`)
}
